export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SidebarNavProfile.vue?vue&type=template&id=7d2051fe&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/sidebar/SidebarNavProfile.vue?vue&type=template&id=7d2051fe&scoped=true
// module id = null
// module chunks = 